var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cx-call-scheduling-iframe"},[(_vm.iframeSrc)?_c('iframe',{attrs:{"src":_vm.iframeSrc,"height":"600","width":"100%","sandbox":"allow-scripts allow-forms allow-same-origin"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }